<template>
  <b-container>
    <b-row align-h="between">
      <b-col cols="4">
        <div v-if="$isLoadingPartner">
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <div v-else-if="$partner && $partner.logo">
          <img :src="$partner.logo.filepath" class="mb-1" style="height: 50px;" />
        </div>
        <div v-else>
          <img src="../../assets/prewoe.png" style="height: 30px;" />
        </div>
      </b-col>
      <b-col cols="3"></b-col>
      <b-col cols="2" class="text-right">
        <b-form>
          <b-form-group>
            <b-form-select
              size="sm"
              v-model="active_language"
              :options="languages"
              value-field="code"
              text-field="name"
              @change="changeLanguage"
            >
              <template v-slot:first>
                <b-form-select-option value="" disabled>Change Language</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <div class="text-center">
      <h4 v-if="$partner && $partner.partner_welcome_text">
        {{ $partner.partner_welcome_text }}
      </h4>
      <h4 v-else>{{ $t("preWoeHelpsYou") }}</h4>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import AzureAuthService from "@/services/AzureAuthService";
import store from "@/store";
import { getSupportedLocales } from "@/helpers/get-supported-locales.js";

export default {
  name: "BillboardLogin",
  data: () => ({
    active_language: "",
    languages: getSupportedLocales()
  }),
  mounted() {},
  methods: {
    changeLanguage() {
      store.dispatch("app/setFrontendLanguage", this.active_language);
    }
  },
  computed: {
    ...mapGetters("layout", {
      $isLoadingPartner: "isLoadingPartner",
      $partner: "partner"
    })
  }
};
</script>
